import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider, authWebResources } from "@ferrivia/auth-web";
import { chatUiResources } from "@ferrivia/chat-ui";
import { labUiResources } from "@ferrivia/lab-ui";
import { journeyUiResources } from "@ferrivia/journey-ui";
import { questionnaireUiResources } from "@ferrivia/questionnaire-ui";
import { createI18n, I18nProvider, mergeResources, resolveLocale } from "@ferrivia/i18n";
import { App } from "./App";
import { UpdateBanner } from "./components/UpdateBanner";
import { clinicResources, usOverlayResources } from "./resources";
import { MARKET } from "./lib/market";
import "./styles.css";

const CLINIC_DEFAULT_LOCALE = "en" as const;

const i18n = createI18n({
  resources: mergeResources(
    clinicResources,
    authWebResources,
    chatUiResources,
    labUiResources,
    journeyUiResources,
    questionnaireUiResources,
  ),
  locale: resolveLocale({ defaultLocale: CLINIC_DEFAULT_LOCALE }),
  market: MARKET,
  overlays: usOverlayResources,
  fallbackLng: CLINIC_DEFAULT_LOCALE,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <AuthProvider baseUrl={import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080"} source="web-clinic">
        <App />
        <UpdateBanner />
      </AuthProvider>
    </I18nProvider>
  </StrictMode>,
);
